module.exports = __webpack_public_path__ + "static/media/developer.9f95f1ad.svg";